import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { TableSetting, ActionResult, TableHeader } from './table-class';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from '../dialog/dialog.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
})

export class TableComponent {
  @Input() Income: ActionResult;
  @Input() TableSetting: TableSetting;
  @Output() DeleteEvent = new EventEmitter<any>();
  @Output() EditEvent = new EventEmitter<any>();
  @Output() MonitorEvent = new EventEmitter<any>();
  @Output() LinkEvent = new EventEmitter<any>();
  @Output() CheckItemEvent = new EventEmitter<any>();
  @Output() CellValueEvent = new EventEmitter<any>();
  @Output() TableInfo = new EventEmitter<any>();
  @ViewChild(MatSort) sort: MatSort;

  CheckAll = false;
  TableData = [];
  DisplayedColumns = [];
  // 本頁該顯示之 datatable
  dataSource: MatTableDataSource<any>;

  constructor(private DlgService: DialogService, private router: Router, private actRoute: ActivatedRoute) { }

  ngOnChanges() {
    this.initTable();
    this.TableData.forEach(item => {
      this.CheckAll = item.checked;
    });
  }

  initTable() {
    let page = 1;
    if (this.Income !== undefined) {
      this.TableData = this.Income.data;
      page = this.Income.draw;
      this.DisplayedColumns = this.TableSetting.CorrespondTableHeard.map(x => x.columnDef);
      if (this.TableSetting.IdColumnName.trim() != '') {
        this.DisplayedColumns.unshift(this.TableSetting.IdColumnName);
      }

      // 取得本頁次該顯示之項目
      this.dataSource = new MatTableDataSource(this.TableData);
      this.dataSource.sort = this.sort;
    }
  }

  DeleteItem(item) {
    let result = this.DlgService.DeleteQuestion();
    result.then((ret) => {
      if (ret === 'Yes') {
        this.DeleteEvent.emit(item);
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  EditItem(item) {
    if (this.EditEvent.observers.length > 0) {
      this.EditEvent.emit(item);
    } else {
      let id = item[this.TableSetting.IdColumnName];
      this.router.navigate(['./', id], { relativeTo: this.actRoute });
    }
  }

  MonitorItem(item) {
    if (this.MonitorEvent.observers.length > 0) {
      this.MonitorEvent.emit(item);
    } else {
      let id = item[this.TableSetting.IdColumnName];
      this.router.navigate(['./', id], { relativeTo: this.actRoute });
    }
  }

  LinkItem(item, colDef) {
    if (this.LinkEvent.observers.length > 0) {
      const data = { item, colDef };
      this.LinkEvent.emit(data);
    }
  }

  CheckAllItem() {
    this.TableData.forEach(item => {
      item.checked = this.CheckAll;
      // 觸發每筆Checked事件
      this.CheckItem(item);
    });
  }
  // 觸發Checked事件
  CheckItem(item) {
    if (this.CheckItemEvent.observers.length > 0) {
      this.CheckItemEvent.emit(item);
    }
  }

  changeCellValue(item: any) {
    this.CellValueEvent.emit(item);
  }

  getCellStyle(column: TableHeader, item) {
    let cStyle = { color: 'rgba(0,0,0,.87)' };
    if (this.TableSetting.CellStyle) {
      cStyle = this.TableSetting.CellStyle;
    }
    return column.CellStyle ? column.CellStyle(item) : cStyle;
  }

  showCell(column: TableHeader, item) {
    return column.cell ? column.cell(item) : this.TableCellConversion(column.columnDef, item[column.columnDef]);
  }

  TableCellConversion(columnName, columnValue) {
    let returnValue = '';
    if (columnName == 'Enabled') {
      returnValue = columnValue == 'True' || columnValue === true ? 'Y' : 'N'
    } else if (columnName == 'UpdateDate') {
      returnValue = columnValue.ToDateTimeString();
    }
    else {
      return columnValue;
    }
    return returnValue;
  }

  ChangeSort() {
    const sortInfo = {
      SortBy: this.sort.active,
      IsAsc: this.sort.direction === 'asc'
    }
    this.TableInfo.emit(sortInfo);
  }

  ShowRowNumber(index): string {
    return '#' + (index + 1 + (this.Income.draw - 1) * 10);
  }

  GetCellAlign(columnType: string): string {
    let align = 'left';
    switch (columnType) {
      case 'checkbox':
      case 'link':
        align = 'center';
        break;
    }
    return align;
  }
}
